import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class AccountMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isGridView: true,
      isToggle: "Address Details",
      totalCount: 0,
      searchByItemName: "",
      tableStatus: "",
      isLoading: false,
      partyList: [],
      partyDetails: {
        partyCode: "",
        accountCodeName: "",
        gstnNo: "",
        state: "",
        isGSTApply: "",
        openBalance: 0,
        openBalanceDRCR: "",
        maintainAc: "",
        hsncode: "",
        hsndesc: "",
        sgst: 0,
        cgst: 0,
        igst: 0,
      },
      stateList: [],
      gstApplyOptions: [{ gst: "Yes" }, { gst: "No" }],
      openBalanceDRCRList: [{ balance: "DR" }, { balance: "CR" }],
      accountGroupList: [],
      validationRules: {
        partyName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        accountCodeName: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "account group name"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllParties(this.state.searchByItemName);
  }

  getAllParties = (searchName) => {
    this.setState({ tableStatus: "Loading..." })
    this.itemMasterServices.getAllParties(searchName).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let length = response.responseData.length;
        if (length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { partyList: response.responseData, totalCount: length },
          () => {
            this.getAllStates();
          }
        );
      } else {
        this.getAllStates();
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllStates = () => {
    this.commonServices.getAllStates().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ stateList: response.responseData }, () => {
          this.getAllAccountGroups();
        });
      } else {
        this.getAllAccountGroups();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllAccountGroups = () => {
    this.commonServices.getAllAccountGroups().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ accountGroupList: response.responseData });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.partyDetails;
    details.partyName = "";
    details.accountCodeName = "";
    details.gstnNo = "";
    details.state = "";
    details.isGSTApply = "";
    details.openBalance = 0;
    details.openBalanceDRCR = "";
    details.maintainAc = "";
    details.hsncode = "";
    details.hsndesc = "";
    details.sgst = 0;
    details.cgst = 0;
    details.igst = 0;
    this.setState({ partyDetails: details, _id: "", validState: validState, searchByItemName: "", tableStatus: "", },
      () => {
        this.getAllParties(this.state.searchByItemName);
      }
    );
  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllParties(this.state.searchByItemName);
    });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.partyDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  getPartyDetailsById = (id) => {
    this.itemMasterServices.getPartyDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        if (details.maintainAc === "") {
          details.maintainAc = "C";
        }
        if (details.isGSTApply === "") {
          details.isGSTApply = "No";
        } else if (details.isGSTApply === "N") {
          details.isGSTApply = "No";
        } else if (details.isGSTApply === "Y") {
          details.isGSTApply = "Yes";
        }
        this.setState(
          { partyDetails: details, _id: details._id, isEditing: true },
          () => {
            this.closeGridView();
          }
        );
      } else {
      }
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.partyDetails;
    details[name] = value.toUpperCase();
    this.setState({ partyDetails: details });
  };

  handleRadioButtonChange = (event) => {
    let value = event.target.value;
    let details = this.state.partyDetails;
    details.maintainAc = value;
    this.setState({ partyDetails: details });
  };

  addEditPartyDetails = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.partyDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditPartyDetails(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.setState({ isEditing: false, isGridView: true, isLoading: false }, () => {
              this.resetForm();
              this.setState({ searchByItemName: "", isLoading: false }, () => {
                this.getAllParties(this.state.searchByItemName);
              });
            });
            this.SwalServices.Success(response.Message);
          } else if (response.statusCode === 409) {
            this.SwalServices.Warning(response.Message);
            this.setState({ isGridView: true, isLoading: false })
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      });
    }
  };

  handleDropdownChange = (e, name) => {
    const selectedYear = e.target.value;

    let details = this.state.partyDetails;
    details[name] = selectedYear;
    this.setState({ partyDetails: details });

  };

  deletePartyDetailsById = (id) => {
    this.itemMasterServices.deletePartyDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.setState({ searchByItemName: "" }, () => {
          this.getAllParties(this.state.searchByItemName);
        });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  render() {
    return (
      <div className="accountMaster-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-2">
              <div className="item-grp">
                <div className="item-search-box w-[50%]">
                  <label>Account Name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    autocomplete="off"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
              </div>
              <button className="add-btn mt-3.5" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
              <div className="table-container" style={{ height: 'calc(100vh - 205px)' }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td className="w-[35%]">Account Name</td>
                      {/* <td>Group Name</td> */}
                      <td className="w-[25%]">GSTN No</td>
                      <td className="w-[15%]">Mobile</td>
                      <td className="w-[15%]">City</td>
                      <td className="w-[10%] !text-center">Action</td>
                    </tr>
                  </thead>
                  {this.state.partyList && this.state.partyList.length > 0 ? (
                    this.state.partyList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td>{item.partyName}</td>
                          {/* <td>{item.accountCodeName}</td> */}
                          <td>{item.gstnNo}</td>
                          <td>{item.mobileNo1}</td>
                          <td>{item.city}</td>
                          <td style={{ textAlign: 'center' }}>
                            <button
                              className="search-btn"
                              onClick={() => this.getPartyDetailsById(item._id)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.deletePartyDetailsById(item._id)
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.partyList
                    && this.state.partyList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.partyList
                    && this.state.partyList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                  <div className="input-grp">
                    <label>Account Name</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.partyName ? "errorInput" : ""}`}
                      type="text"
                      id="partyName"
                      name="partyName"
                      autocomplete="off"
                      value={this.state.partyDetails.partyName}
                      onChange={(event) =>
                        this.handleChange(event, "partyName")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.partyName}
                    /> */}
                  </div>
                  <div className="item-Inner-grp grid !grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Group Name</label>
                      <select
                        className={`inputFocus ${this.state.validState?.error?.accountCodeName ? "errorInput" : ""}`}
                        name="accountCodeName"
                        value={this.state.partyDetails.accountCodeName}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "accountCodeName")
                        }
                      >

                        <option>Select</option>
                        {this.state.accountGroupList &&
                          this.state.accountGroupList.length > 0 &&
                          this.state.accountGroupList.map((state, key) => (
                            <option>{state.accountGroupname}</option>
                          ))}
                      </select>
                      {/* <ValidationText
                        error={this.state.validState.error.accountCodeName}
                      /> */}
                    </div>
                    <div className="input-grp">
                      <label>GST No</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="gstnNo"
                        name="gstnNo"
                        autocomplete="off"
                        value={this.state.partyDetails.gstnNo}
                        onChange={(event) => this.handleChange(event, "gstnNo")}
                      />
                    </div>
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                  <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>State Name</label>
                      <select
                        name="state"
                        value={this.state.partyDetails.state}
                        onChange={(e) => this.handleDropdownChange(e, "state")}
                      >
                        <option>Select</option>
                        {this.state.stateList &&
                          this.state.stateList.length > 0 &&
                          this.state.stateList.map((state, key) => (
                            <option>{state.stateName}</option>
                          ))}
                      </select>
                    </div>
                    <div className="input-grp">
                      <label>GST Apply</label>
                      <select
                        name="isGSTApply"
                        value={this.state.partyDetails.isGSTApply}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "isGSTApply")
                        }
                      >
                        <option>Select</option>
                        {this.state.gstApplyOptions &&
                          this.state.gstApplyOptions.length > 0 &&
                          this.state.gstApplyOptions.map((state, key) => (
                            <option>{state.gst}</option>
                          ))}
                      </select>

                    </div>
                  </div>
                  <div className="input-grp">
                    <label>Open Balance</label>
                    <div className="inputs flex items-center gap-2.5">
                      <input
                        className="inputFocus !w-[80%]"
                        type="number"
                        id="openBalance"
                        name="openBalance"
                        autocomplete="off"
                        value={this.state.partyDetails.openBalance}
                        onChange={(event) =>
                          this.handleChange(event, "openBalance")
                        }
                      />
                      <select
                        className="!w-[20%]"
                        name="openBalanceDRCR"
                        value={this.state.partyDetails.openBalanceDRCR}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "openBalanceDRCR")
                        }
                      >
                        <option>Select</option>
                        {this.state.openBalanceDRCRList &&
                          this.state.openBalanceDRCRList.length > 0 &&
                          this.state.openBalanceDRCRList.map((state, key) => (
                            <option>{state.balance}</option>
                          ))}
                      </select>
                    </div>

                  </div>
                </div>
                {this.state.partyDetails.isGSTApply === "Yes" ? (
                  <>
                    <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                      <div className="input-grp">
                        <label>HNS/SAC Code</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="hsncode"
                          name="hsncode"
                          autocomplete="off"
                          value={this.state.partyDetails.hsncode}
                          onChange={(event) =>
                            this.handleChange(event, "hsncode")
                          }
                        />
                      </div>
                      <div className="input-grp">
                        <label>Description</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="hsndesc"
                          name="hsndesc"
                          autocomplete="off"
                          value={this.state.partyDetails.hsndesc}
                          onChange={(event) =>
                            this.handleChange(event, "hsndesc")
                          }
                        />
                      </div>
                    </div>
                    <div className="item-grp grid !grid-cols-4 !gap-2.5 mb-3">
                      <div className="input-grp">
                        <label>SGST[%]</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="sgst"
                          name="sgst"
                          autocomplete="off"
                          value={this.state.partyDetails.sgst}
                          onChange={(event) => this.handleChange(event, "sgst")}
                        />
                      </div>
                      <div className="input-grp">
                        <label>CGST[%]</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="cgst"
                          name="cgst"
                          autocomplete="off"
                          value={this.state.partyDetails.cgst}
                          onChange={(event) => this.handleChange(event, "cgst")}
                        />
                      </div>
                      <div className="input-grp">
                        <label>IGST[%]</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="igst"
                          name="igst"
                          autocomplete="off"
                          value={this.state.partyDetails.igst}
                          onChange={(event) => this.handleChange(event, "igst")}
                        />
                      </div>
                    </div>
                  </>
                ) : null}


                <div className="input-grp w-full ">
                  <div className="mb-[3px] text-[15px] font-medium text-[#474747]">Maintain A/C</div>
                  <label className="!flex !items-center !gap-1">
                    <input
                      className="w-[14px] h-[14px]"
                      type="radio"
                      name="maintainAcc"
                      value="B"
                      autocomplete="off"
                      checked={this.state.partyDetails.maintainAc === "B"}
                      onChange={(event) =>
                        this.handleRadioButtonChange(event)
                      }
                    />
                    Bill Wise
                  </label>
                  <label className="!flex !items-center !gap-1">
                    <input
                      className="w-[14px] h-[14px]"
                      type="radio"
                      name="maintainAcc"
                      value="C"
                      autocomplete="off"
                      checked={this.state.partyDetails.maintainAc === "C"}
                      onChange={(event) =>
                        this.handleRadioButtonChange(event)
                      }
                    />
                    Cummulative
                  </label>

                </div>


              </div>
              <div className="btn-grp mt-3.5">
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditPartyDetails()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditPartyDetails()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  className="cancel-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.openGridView()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default AccountMaster;
